import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useSportConfiguration } from "~hooks/useSportConfiguration";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useImportSeasonOfficials = () => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const request = useApi();
  const { seasonOfficialRoles } = useSportConfiguration();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: (fileName) =>
      request(`${sport}/o/${organizationId}/seasons/${seasonId}/personRoles/import`, {
        method: "POST",
        body: {
          fileName,
          importName: "season officials",
          personRoles: seasonOfficialRoles,
        },
      }),
  });
};
